window.addEventListener('load', function () {
    if (document.querySelectorAll('.ctaElement').length) {
        document.addEventListener(
            'click',
            function (event) {
                // Only fire if the target has id copy
                if (!event.target.matches('.copyLink')) return;

                if (!navigator.clipboard) {
                    // Clipboard API not available
                    return;
                }

                // the clicked button
                const btn = event.target;
                const span = btn.querySelector('span');

                // get data attribute
                const url = btn.getAttribute('data-url');
                const text = btn.textContent;

                try {
                    navigator.clipboard.writeText(url);
                    span.innerText = 'Link kopiert';
                    btn.classList.add('copied');
                    setTimeout(function () {
                        // restore old value after 3 seconds
                        span.innerText = text;
                        btn.classList.remove('copied');
                    }, 1200);
                } catch (err) {
                    console.error('Failed to copy!', err);
                }
            },
            false,
        );
    }
});
